import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            更多精彩韩漫等你发现
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            韩漫网每周更新热门韩漫资源，收藏你喜欢的作品，开启属于你的漫画之旅
          </p>
          <Link
            to="/category/fantasy"
            className="mt-6 inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
          >
            探索更多韩漫
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          {['女神降临', '我独自升级', '全知读者视角', '剑尊归来', '反派千金'].map(
            (name, i) => (
              <Link
                key={name}
                to={`/article/${i + 1}`}
                className="px-5 py-2.5 bg-background-50 rounded-full text-sm text-foreground-700 whitespace-nowrap hover:text-primary-500 hover:bg-primary-50 transition-all duration-300 cursor-pointer border border-background-200/50"
              >
                {name}
              </Link>
            )
          )}
        </div>
      </div>
    </section>
  );
}